import { withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "./TagsStyle";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import Table from "../../../components/Table/Table";
import ModalTags from "./ModalTags";
import Notification from "../../../components/Notification";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import {
  notificationDefault,
  pageableDTODefault,
  tagDefault,
  columns,
} from "./constants";
import {
  findAllTag,
  findByIdTag,
} from "../../../services/TagService";

const Tags = ({ classes }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [last, setLast] = useState(true);
  const [pageableDTO, setPageableDTO] = useState(pageableDTODefault);
  const [search, setSearch] = useState("");
  const [tags, setTags] = useState([]);
  const [notification, setNotification] = useState(notificationDefault);
  const [tagSelecionada, setTagSelecionada] = useState(tagDefault);

  useEffect(() => {
    loadTags({ isClear: true });
  }, [pageableDTO.sortDir, pageableDTO.sortField]);

  const handleCreate = () => {
    setTagSelecionada(tagDefault);
    setOpen(true);
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const onKeypressSearch = (e) => {
    if (e.key === "Enter") {
      handleClickSearch();
    }
  };

  const handleClickSearch = () => {
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadTags({ isClear: true });
  };

  const handleClickClear = () => {
    setSearch("");
    setPageableDTO({ ...pageableDTO, pageNumber: 0 });
    loadTags({ isClear: true, isClearSearching: true });
  };

  const openNotification = ({ message, type }) => {
    setNotification({
      open: true,
      type,
      message,
    });

    const timeoutId = setTimeout(() => {
      resetNotification();
      clearTimeout(timeoutId);
    }, 4000);
  };

  const resetNotification = () => {
    setNotification(notificationDefault);
  };

  const closeAlertMessage = () => {
    setNotification(notificationDefault);
  };

  const loadTags = async (options) => {
    try {
      setLoading(true);

      const pageable = {
        ...pageableDTO,
        pageNumber: options?.isClear ? 0 : pageableDTO.pageNumber,
      };

      const textSearch = options?.isClearSearching ? "" : search;

      const response = await findAllTag({
        search: textSearch,
        pageableDTO: pageable,
      });

      const { content, last } = response;
      const pageNumber = options?.isClear ? 0 : pageable.pageNumber + 1;

      setTags(options?.isClear ? content : [...tags, ...content]);
      setLast(last);
      setPageableDTO({ ...pageableDTO, pageNumber });
    } catch (e) {
      openNotification({
        message: "Erro ao carregar as tags",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClickOrdenar = (value) => {
    const sortDir =
      pageableDTO.sortField !== value
        ? "ASC"
        : pageableDTO.sortDir === "ASC"
        ? "DESC"
        : "ASC";
    setPageableDTO({
      ...pageableDTO,
      pageNumber: 0,
      sortDir: sortDir,
      sortField: value,
    });
  };

  const handleSelectTag = async (tagId) => {
    const response = await findByIdTag({ id: tagId });
    
    setTagSelecionada(response);
    setOpen(true);
  };

  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("TAGs")} />
      <HeaderConfiguracoesButtonNovo
        idPrefix="cfg-tag"
        title="TAGs"
        labelButton="Nova tag"
        handleClickNovo={handleCreate}
        search={{
          handleChange: handleSearchChange,
          value: search,
          onKeypress: onKeypressSearch,
          handleClickClear: handleClickClear,
          onClickButtonSearch: handleClickSearch,
        }}
      />
      <div className={classes.tableContainer}>
        <Scroll
          loadMore={() => loadTags()}
          hasMore={last}
          pageStart={0}
          initialLoad={false}
          className={classes.scrollContainer}
          isLoading={loading}
        >
          <Table
            dados={tags}
            columns={columns}
            clickable={true}
            handleClick={handleSelectTag}
            ordenarTabela={{
              sortField: pageableDTO.sortField,
              sortDir: pageableDTO.sortDir,
            }}
            comOrdenacao
            handleClickOrdenar={handleClickOrdenar}
          />
          {tags?.length === 0 && !loading && (
            <div className={classes.notFoundContainer}>
              <MensagemListaVazia />
            </div>
          )}
        </Scroll>
      </div>
      {open && (
        <ModalTags
          open={open}
          onClose={() => setOpen(false)}
          tagSelecionada={tagSelecionada}
          loadTags={loadTags}
          openNotification={openNotification}
        />
      )}
      <Notification
        close={closeAlertMessage}
        reset={closeAlertMessage}
        isOpen={notification.open}
        variant={notification.type}
        message={notification.message}
      />
    </div>
  );
};

export default withStyles(styles)(Tags);